import { Outlet, Navigate } from 'react-router-dom'
import React from 'react'

const PrivateRoutes = () => {
    //let auth = sessionStorage.getItem('token');
    let auth = { token: sessionStorage.getItem('token') }
    return (
        auth.token ? <Outlet /> : <Navigate to='/' />
        // auth === true? <Outlet/> : <Navigate to='/login'/>
    )
}

export default PrivateRoutes